import React, { useContext, useEffect, useState } from 'react';
import store from '../../../../redux/store';
import { useNavigate, useParams } from 'react-router-dom';
import { AlertContext, Alert_, Grey_Link, PageAlwaysVisible, PageSixty, PageSubtitle, PageTitle, Section_Title, CardsForty, Preset_Card, Sixty_Stat_Loader, Actions_, Grey_, Main_, Row_Card, Sixty_Card_Loader } from 'monica-alexandria';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Report_Title from './components/Report_Title';
import Slider_Section from './components/slider/Handler_';
import { AuthContext } from '../../../../services/authentication/Guard';
import { checkOwnership } from '../../../../helpers/verifyToolOwnership';
import dummyData from '../../data/dummyData.json';
import { getClientCampaigns } from '../../services/api/GoogleApi';
import { calculateDaysBetweenDates, formatDates } from './utils/dates';

import { TemplateWrapper, BuilderContent } from './CREATE_REPORT.css';
import { constructKpis } from './utils/constructKpis';
import { assignDefaultKpis } from './utils/assignDefaultKpis';
import { handleFinalizeReport } from './utils/finalize';
import Campaigs_Section from './components/Campaigns_Section';
import { fetchCampaignData } from './utils/fetchCampaignData';
import { handleOldReport } from './utils/handleOldReport';



const environment = process.env.REACT_APP_SERVER;


const CREATE_REPORT = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const lang = store.getState().selectedLanguage ? store.getState().selectedLanguage : 'en';
    const auth = useContext(AuthContext);
    const userId = auth?.user?.sub;

    /* For edit report */ 
    const { id } = useParams();
    const isEditMode = id ? true : false

    /* For tool ownership validation */
    const [hasCheckOwnership, setHasCheckOwnership] = useState(false);

    /* Slider */ 
    const [slider, toggleSlider] = useState(false);
    const [activeSlider, setActiveSlider] = useState('');
    const [activeSlot, setActiveSlot] = useState();

    const handleSliderClick = (slider, item) => {
        toggleSlider(true);
        setActiveSlider(slider);
        if (item) setActiveSlot(item);
    };

    const closeSlider = () => {
        toggleSlider(false);
    };

    /* Alert */
    const { alerts, setAlerts } = useContext(AlertContext);

    const alertMessage = (message, status) => {
        setAlerts([
            ...alerts,
            {
                message: {
                    text: message,
                    status: status,
                },
            },
        ]);
    };

    /* For loading kpis */
    const [isLoading, setIsLoading] = useState({
        loading: false,
        loadingCampaignIds: [],
    });

    /* LocalStorage Google Data */
    const GoogleSourceData = store.getState().googleSource;
    const googleUserProfile = GoogleSourceData?.userProfile;
    const managerAccount = GoogleSourceData?.managerAccount;
    const clientAccount = GoogleSourceData?.clientAccount;
    const selectedDates = formatDates(GoogleSourceData?.dates); // To YYYY-MM-DD
    const clientId = clientAccount?.id;
    const clientResource = clientAccount.resourceName;
    const accessToken = googleUserProfile?.accessToken;
    const managerAccountId = managerAccount?.id;
   

    /* Report obj meant for creatig report */
    const [report, setReport] = useState({
        userId: userId,
        googleUserProfile,
        managerAccount,
        clientAccount, 
        title: "",
        days: calculateDaysBetweenDates(selectedDates) || 0, 
        dates: selectedDates,
        campaigns: []
        // template: [],
    })
    /* report.campaigns format:         
        campaigns: [{
            campaign: {},
            comment: "",
            kpis: [],
        }]
    */

    /* Report obj meant to be assigned the fetched data */
    const [googleResponses, setGoogleResponses] = useState({
        campaigns: [],
        campaignData: []
    });
    /* campaignData format 
        [{
            campaign: {},
            metrics: {},
            kpis: [],
        }]
    /*

    /* Fetch either real or dummy data */
    const initActions = () => {
        const get_Client_Campaigns = () => {
            getClientCampaigns(clientResource, managerAccountId, accessToken)
                .then((response) => {
                    const campaigns = response?.data?.data?.clientCampaigns;
                    if ( campaigns && campaigns?.length > 0 && !isEditMode ) {
                        setGoogleResponses({...googleResponses, campaigns: campaigns});
                    } else if ( campaigns && campaigns?.length > 0 && isEditMode ) {
                        handleOldReport(campaigns, id, report, setReport, googleResponses, setGoogleResponses, accessToken, managerAccountId, clientId, lang, t, alertMessage, navigate).then((res) => {
                            // Forgot to use it as promise. Login inside the function
                        }).catch(err=>{
                            console.error(err);
                            alertMessage((t("Session expired")),'Error');
                            navigate(`/${lang}/google/connect`);
                        })
                    } else {
                        alertMessage((t("Session expired")),'Error');
                        navigate(`/${lang}/google/connect`);
                    }
                })
                .catch(error=>{
                    console.error(error); 
                    alertMessage((t("Session expired")),'Error');
                    navigate(`/${lang}/google/connect`);
                })
        }

        if ( environment !== 'LOCAL' ) get_Client_Campaigns()
        else setGoogleResponses({...googleResponses, campaigns: dummyData.getClientCampaigns.clientCampaigns})
    }

    /* Fetch Campaign Data. It assigns the data to googleResponses */
    useEffect(() => {
        fetchCampaignData(report, googleResponses, setGoogleResponses, clientId, managerAccountId, accessToken, alertMessage, isLoading, setIsLoading)
    },[report.campaigns.length])

    /* Assign default kpis to report from googleResponses */
    useEffect(() => {
        assignDefaultKpis(googleResponses, setGoogleResponses, report, setReport); 
    },[googleResponses.campaignData.length])

    
    /* Initilize Page Logic */
    useEffect(() => {
        initActions();
    },[])


    /* Validate Tool Ownership */
    useEffect(() => {
        if (userId) checkOwnership(userId, navigate, lang, setHasCheckOwnership);
    }, [userId]);


    console.log('googleResponses',googleResponses);
    console.log('report',report);
  return (
    <>
        <Helmet>
            <title>Adsnap | Create report</title>
        </Helmet>
            
        { hasCheckOwnership && <PageSixty>
           
             <Alert_ messages={alerts} />
            {slider && (
                <Slider_Section
                    activeSlider={activeSlider}
                    activeSlot={activeSlot}
                    closeSlider={closeSlider}
                    alertMessage={alertMessage} 
                    report={report}
                    setReport={setReport}
                    googleResponses={googleResponses}
                    setGoogleResponses={setGoogleResponses}
                    managerAccountId={managerAccountId}
                    accessToken={accessToken}
                    clientId={clientId}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                />
            )}


            <PageAlwaysVisible>
                <PageTitle>
                    <Grey_Link 
                        iconLeft="Back" 
                        id={"AdSnap_Google_Create_Report_1"} 
                        onClick={() => navigate(isEditMode ? `/${lang}/google/reports` : `/${lang}/google/dates`)} 
                        noPadding 
                    />
                    <h1>{t('Report creation')}</h1>
                </PageTitle>       
                <PageSubtitle>
                            <p>{t("Customize the content that you want to show to your client on a page. You can choose which sections and Key Performance Indicators (KPIs) to include or remove depending on what you think is important for your client to see. This can help you tailor your presentation to your client's specific needs and interests")}</p>
                </PageSubtitle>

                { googleResponses.campaigns?.length > 0 ? <BuilderContent>  {/* Waiting for campaigns to load before rendering */}
                
                    <Report_Title 
                        handleSliderClick={handleSliderClick}
                        title={report?.title}
                    /> 


                    <Campaigs_Section 
                        report={report}
                        handleSliderClick={handleSliderClick}
                        isLoading={isLoading}
                    />
        

                    { /* Now showing if all campaigns are used at the report */ }
                    { (report.campaigns.filter(obj => obj.kpis?.length > 0)?.length) !== googleResponses?.campaigns?.length 
                        && <Row_Card
                            icon="Add"
                            text={t("Campaign")}
                            id={"AdSnap_Google_Create_Report_2"}
                            onClick={() => handleSliderClick('select_campaign')}
                        /> 
                    }

                    <Actions_>
                        <Grey_
                            text={t("Back")}
                            id={"AdSnap_Google_Create_Report_3"}
                            onClick={() => navigate(isEditMode ? `/${lang}/google/reports` : `/${lang}/google/dates`)}
                            iconLeft={'Back'}
                        />
                        <Main_
                            text={!isEditMode ? (t("Create")) : (t("Update"))}
                            id={"AdSnap_Google_Create_Report_4"}
                            onClick={() => handleFinalizeReport(report, alertMessage, navigate, lang, isEditMode)}
                            iconRight={'Check'}
                            className={ report.campaigns.some( obj => obj.kpis?.length > 0 ) 
                                    ?  ''
                                    :  'DisableCreation'
                            }
                        />
                    </Actions_>

                </BuilderContent> : <Sixty_Card_Loader />}
            </PageAlwaysVisible>


            {/* { googleResponses.campaigns.length > 0 && <PageAlwaysVisible>       
                <TemplateWrapper>
                    <Section_Title text={t('Choose template')} />
                    <CardsForty>
                        {[['test1', 'test2'],['anotherTest1', 'anotherTest2']]?.map((response, index) => {
                            return (
                                <Preset_Card
                                    // onClick={() => handleTemplateChange(JSON.stringify(response?.template),response.date)}
                                    title={'Some title'}
                                    // selected = {isSelected}
                                    items ={response}
                                    isJson={false}
                                />  
                            )
                        })}
                    </CardsForty> 
                </TemplateWrapper>
            </PageAlwaysVisible> } */}
            
        </PageSixty> }
    </>
  );
};

export default CREATE_REPORT;